require.context("./", true, /\.(gif|jpg|png|svg|webp)$/)
